/**
 * The brand: lowercase "pagerless" in the LCD face. One component everywhere.
 * `topbar` sits on paper; `engraved` is cut into the pager's dark bezel (recessed, low contrast, no glow).
 */
export function Wordmark({ variant = "topbar" }: { variant?: "topbar" | "engraved" }) {
  // Never the bare variant name as a class: "topbar" is also the header's class and would restyle the logo.
  return <span className={variant === "engraved" ? "wordmark engraved" : "wordmark"}>pagerless</span>;
}
